import RawColor from "../api/model/colors/RawColor";
import ApiJiraAttachment from "../api/model/integrations/barrel/JiraAttachment";

import Model from "./model";

class JiraAttachment extends Model {
    id: string;
    _id: string;
    deploymentUrl: string;
    type: string;
    itemId: string;
    issueKey: string;
    issueUrl: string;
    details?: JiraAttachmentDetails;

    constructor(attachmentData: ApiJiraAttachment) {
        super();

        const {
            _id,
            deploymentUrl,
            type,
            itemId,
            issueKey,
            issueUrl,
            details
        } = attachmentData;

        this.id = _id;
        this._id = _id;
        this.deploymentUrl = deploymentUrl;
        this.type = type;
        this.itemId = itemId;
        this.issueKey = issueKey;
        this.issueUrl = issueUrl;
        this.details = details;
    }
}

export type JiraAttachmentDetails = {
    summary: string;
    dueDate?: string;
    updated: string;
    issueType: {
        iconUrl: string;
    };
    status: JiraAttachmentStatus;
    assignee?: {
        displayName: string;
        avatarUrl: string;
    };
    priority?: {
        name: string;
        iconUrl: string;
    };
    parent?: {
        issueKey: string;
    };
};

export type JiraAttachmentStatus = {
    name: string;
    statusCategory: {
        name: string;
        textColor: RawColor;
        backgroundColor: RawColor;
    };
};

export default JiraAttachment;
